import React from 'react';
const NotFoundScreen = () => {
    return (
        <>
        <div className="container">
            <h2>The page is not available!</h2>
        </div>
        </>
    );
};

export default NotFoundScreen;